import { render, staticRenderFns } from "./AreaTimeBase.vue?vue&type=template&id=f4fa6c1a&scoped=true"
import script from "./AreaTimeBase.vue?vue&type=script&lang=js"
export * from "./AreaTimeBase.vue?vue&type=script&lang=js"
import style0 from "./AreaTimeBase.vue?vue&type=style&index=0&id=f4fa6c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fa6c1a",
  null
  
)

export default component.exports